import { Fragments, RegionalBlockTypeEnum } from "requests";

export const getCalculatedDose = (
  regionalBlocks: Fragments.StoredRegionalBlocks
) => {
  const regionalOralBlocks = regionalBlocks.filter(
    block => block.type === RegionalBlockTypeEnum.RegionalOralBlocks
  );
  if (!regionalOralBlocks.length) {
    return "Calculated dose: -";
  }

  const defaultValue = {
    minVolumeSum: 0,
    maxVolumeSum: 0,
    medications: [] as string[]
  };

  const calculatedDose = regionalOralBlocks.reduce(
    (result, block) => ({
      minVolumeSum:
        result.minVolumeSum +
        (block.volumeRangeMin ? +block.volumeRangeMin.toFixed(3) : 0),
      maxVolumeSum:
        result.maxVolumeSum +
        (block.volumeRangeMax ? +block.volumeRangeMax.toFixed(3) : 0),
      medications: [...result.medications, block.medication]
    }),
    defaultValue
  );

  return `Calculated dose: ${calculatedDose.minVolumeSum.toFixed(
    3
  )}-${calculatedDose.maxVolumeSum.toFixed(
    3
  )} mLs ${calculatedDose.medications.join(", ")}`;
};
